import { getIntegrations } from "../apis/workspace/integrations";
import { useStoreIntegrations } from "../stores/useStoreIntegrations";
import { useSmartQuery } from "./useSmartQuery";

export const useIntegrations = (workspaceId) => {
  const { integrations, setIntegrations } = useStoreIntegrations();

  const shouldFetch = !!workspaceId && !integrations;

  const query = useSmartQuery(
    ["get_integrations", workspaceId],
    () =>
      getIntegrations({
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setIntegrations,
    }
  );

  return {
    integrations,
    ...query,
  };
};
